import * as React from "react";
function SvgScene(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M.93 9.4A.91.91 0 010 8.47V.93A.91.91 0 01.93 0h7.54a.91.91 0 01.93.93.91.91 0 01-.93.94h-6.6v6.6a.85.85 0 01-.94.93zM8.47 32H.93a.91.91 0 01-.93-.93v-7.54a.91.91 0 01.93-.93.91.91 0 01.94.93v6.6h6.6a.91.91 0 01.93.94.87.87 0 01-.93.93zm22.6-22.6a.91.91 0 01-.94-.93v-6.6h-6.6a.91.91 0 01-.93-.94.87.87 0 01.93-.93h7.54a.91.91 0 01.93.93v7.54a.87.87 0 01-.93.93zM7.05 18A9 9 0 0125 18h-2a7 7 0 00-13.93 0zm24 14h-7.52a.94.94 0 010-1.87h6.6v-6.6a.94.94 0 011.87 0v7.54a.91.91 0 01-.93.93zM5 9.33a1 1 0 111.1-1.66l3 2A1 1 0 118 11.33zm22.1 0l-3 2A1 1 0 0123 9.67l3-2a1 1 0 111.1 1.66zM15 4a1 1 0 012 0v4a1 1 0 01-2 0zM4.5 21.25a1 1 0 010-2H28a1 1 0 010 2zM8 25a1 1 0 010-2h16a1 1 0 010 2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgScene);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
